import React from 'react'
import { View, Modal, Platform } from 'react-native'
import tw from 'tailwind-rn'

import styles from './styles'
import * as colors from '../../config/colors'

type Props = {
  visible: boolean
}

const HGModalFull = (props: Props) => {
  const { children, style, visible } = props

  const isWeb = Platform.OS === 'web'

  if (isWeb && !visible) return null

  return (
    <View
      style={[
        {
          backgroundColor: colors.beige,
        },
        Platform.OS === 'web'
          ? [
              tw(
                'absolute top-0 left-0 border-none z-50 w-full h-full flex items-center justify-start'
              ),
            ]
          : [],
      ]}
    >
      <Modal
        animationType="slide"
        {...props}
        style={
          isWeb && {
            maxWidth: 450,
            alignSelf: 'auto',
          }
        }
      >
        <View style={[styles.modalFullContainer, style]}>{children}</View>
      </Modal>
    </View>
  )
}

export default HGModalFull
